module.exports = __webpack_public_path__ + "img/17615-a-beautiful-sunset-pv.e7754fa0.jpg";